module.exports = __webpack_public_path__ + "img/11_7.b948fde9.png";